import { Toggle, Button, Switch } from '@nexelem/components';
import { GanttShowOnTask } from './GanttShowOnTask';
import { KanbanShowOnTask } from './KanbanShowOnTask';
import { useCustomTranslation } from '../../../../../../hooks';
import { TaskMainValueOptions } from '../useProductionPlanSettings.types';
import { useProductionPlanSettings } from '../useProductionPlanSettings';
import { Drawer } from '@nexelem/drawer';

export const TasksSettingsTab = () => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');

  const showDependencies = useProductionPlanSettings((state) => state.gantt.showDependencies);
  const ganttProductColors = useProductionPlanSettings((state) => state.gantt.ganttProductColors);
  const mainValue = useProductionPlanSettings((state) => state.taskMainValue);

  const toggleGanttProductColors = useProductionPlanSettings((state) => state.toggleGanttProductColors);
  const toggleShowDependencies = useProductionPlanSettings((state) => state.toggleGanttShowDependencies);
  const setTaskMainValue = useProductionPlanSettings((state) => state.setTaskMainValue);
  const reset = useProductionPlanSettings((state) => state.reset);

  return (
    <>
      <Drawer.Content>
        <div className="mb-6 flex items-center gap-6">
          <span className="text-t14-sb text-text-secondary">{tWrapper('mainValue')}</span>
          <Toggle.Root value={mainValue} onChange={setTaskMainValue}>
            <Toggle.Button value={TaskMainValueOptions.PRODUCT}>{tWrapper('taskValueToggle.product')}</Toggle.Button>
            <Toggle.Button value={TaskMainValueOptions.ID}>{tWrapper('taskValueToggle.id')}</Toggle.Button>
          </Toggle.Root>
        </div>
        <GanttShowOnTask />
        <div className="mt-6 mb-6 flex items-center gap-6 pl-2">
          <span className="text-t14-sb text-text-secondary">{tWrapper('showDependencies')}</span>
          <Switch
            checked={showDependencies}
            leftContentText={tWrapper('showDependenciesToggle.on')}
            rightContentText={tWrapper('showDependenciesToggle.off')}
            onClick={toggleShowDependencies}
          />
        </div>
        <div className="mb-6 flex items-center gap-6 pl-2">
          <span className="text-t14-sb text-text-secondary">{tWrapper('colorSameProducts')}</span>
          <Switch
            checked={ganttProductColors}
            leftContentText={tWrapper('showDependenciesToggle.on')}
            rightContentText={tWrapper('showDependenciesToggle.off')}
            onClick={toggleGanttProductColors}
          />
        </div>
        <KanbanShowOnTask />
      </Drawer.Content>
      <Drawer.Footer>
        <Button variant="text" onClick={reset}>
          {t('common.reset')}
        </Button>
      </Drawer.Footer>
    </>
  );
};
